// src/wrappers.js
import React from "react"
import { Provider } from "react-redux"
import store from "@store"
import Layout from "@components/Layouts"
import { ThemeProvider } from "theme-ui"
import { Themed } from "@theme-ui/mdx"
import { GlobalStyle } from "@src/index"
import theme from "@src/theme"

// Shared Redux wrapper - use in both SSR and browser
export const wrapRootElement = ({ element }) => {
    return (
        <Provider store={store}>
            {element}
        </Provider>
    )
}

export const wrapSSRootElement = ({ element }) => {
    return (
        <Provider store={store}>
            {element}
        </Provider>
    )
}

// // SSR-specific page wrapper (for gatsby-ssr.js)
export const ssrWrapPageElement = ({ element, props }) => {
    return (
        <ThemeProvider theme={theme}>
            <Themed.root>
                <Layout border={props?.pageContext?.border}>
                    <GlobalStyle />
                    {element}
                </Layout>
            </Themed.root>
        </ThemeProvider>
    )
}

// // Browser-specific page wrapper (for gatsby-browser.js)
export const browserWrapPageElement = ({ element, props }) => {
    return <ThemeProvider theme={theme}>
        <Themed.root>
            <Layout border={props?.pageContext?.border}>
                <GlobalStyle />
                {element}
            </Layout>
        </Themed.root>
    </ThemeProvider>
}